export default "/assets/images/big-sneeze4.png?eab8e64a3f29ae46e03af1b8be121d4f";